import { render, staticRenderFns } from "./AiBookUserCustomCategory.vue?vue&type=template&id=41582374&scoped=true"
import script from "./AiBookUserCustomCategory.vue?vue&type=script&lang=js"
export * from "./AiBookUserCustomCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41582374",
  null
  
)

export default component.exports